//antd
import Row from 'antd/lib/row'
import Image from 'antd/lib/image'
import Flex from 'antd/lib/flex'
import Button from 'antd/lib/button'
import {ContactsOutlined} from '@ant-design/icons'

import TuanisLogo from '../../assets/TuanisExpressLogo.svg'

const Header = () => {

    return <Flex vertical className='py-5'>
        <Row className='my-2'>
            <Image width={250} src={TuanisLogo} preview={false} alt="Tuani's Express" />
        </Row>
        <Row className='my-2 border-start border-light border-5 border-opacity-50'>
            <h1 className='text-ft-c1 display-2 text-start font-bold w-50'>Pide lo que quieras en USA y envialo a Nicaragua con Tuani's</h1>
        </Row>
        <Row className='my-2'>
            <Button shape="round" size='large' className='text-ft-c2' icon={<ContactsOutlined />} href='#contact'>Contáctanos</Button>
        </Row>
    </Flex>

}

export default Header